import axiosInstance from "../../../helpers/api";

export const getAllSections = (body) => {
  return axiosInstance.get("students/chapters/sections", body);
};

export const getSection = (id) => {
  return axiosInstance.get(`/students/chapters/for_section/${id}`);
};
